import axios from 'axios';
import store from '../main/vue-store';

export default function execute() {
  let isAlreadyFetchingAccessToken = false;
  let subscribers = [];

  function onAccessTokenFetched(access_token) {
    subscribers = subscribers.filter(callback => callback(access_token));
  }

  function addSubscriber(callback) {
    subscribers.push(callback);
  }

  axios.interceptors.request.use(config => {
    if (
      store.getters['auth/access_token']
      && !config.excludeAccessToken
      && !config.url.includes('anonymous')
    ) {
      config.headers['Authorization'] = `Bearer ${store.getters['auth/access_token']}`;
    }

    return config;
  }, error => {
    return Promise.reject(error);
  });

  axios.interceptors.response.use(response => {
    return response;
  }, async error => {
    const {config, response} = error;
    const originalRequest = config;
    const url = config.url;

    if (response?.status === 401 && url === '/marketplace/api/user/refresh-token') {
      await store.commit('auth/auth_refresh_token_failed');
      await store.commit('marketplace/reset_cart_data');
    }

    if (response?.status === 401 && url !== '/marketplace/api/user/login') {
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true;
        store.dispatch('auth/refreshToken').then(res => {
          isAlreadyFetchingAccessToken = false;
          onAccessTokenFetched(res.access_token);
        });
      }

      return new Promise(resolve => {
        addSubscriber(access_token => {
          originalRequest.headers.Authorization = 'Bearer ' + access_token;
          resolve(axios(originalRequest));
        });
      });
    }

    return Promise.reject(error);
  });
}
